import * as PIXI from 'pixi.js';
import {Main} from '../Main';
import {Const} from '../Const';
import {TweenMax,TimelineMax,Sine, Power2} from "gsap";
//プラグインの読み込み
import 'pixi-picture';
import {TimelinePlus} from './TimelinePlus';

export class Button {

	container:PIXI.Container;
	inner:PIXI.Container;
	back:PIXI.Sprite;
	line:PIXI.Graphics;
	border:Boolean;

	id:number;
	num:string;
	text:string;
	link:string;
	target:string;

	numText:PIXI.Text;
	textText:PIXI.Text;

	fontSizeBase:number = 62.5*1.6 / 10;

	mask:PIXI.Graphics;

	constructor(id:number,num:string,text:string,link:string,target:string,border:Boolean) {
		this.id = id;
		this.num = num;
		this.text = text;
		this.link = link;
		this.target = target;
		this.border = border;

		this.back = new PIXI.Sprite(PIXI.loader.resources["img/top/white.png"].texture);
		//ここがキモ
		this.back.pluginName='picture';
		this.back.interactive = true;
		this.back.alpha = 0;
		Main.instance.stage.addChild(this.back);

		
		this.mask = new PIXI.Graphics();
		//this.mask.beginFill(0xFF0000);
		//this.mask.drawRect(0,0,this.back.width,this.back.height);
		//this.mask.endFill();

		// テキストオブジェクトを作る
		//数字
		//  font-size: 5.3rem;
  	//margin-right: 0.2em;
		var numStyle = {
			fontSize:(this.fontSizeBase*5.3),
			letterSpacing:1,
			fontFamily:'Oswald,sans-serif', 
			fill:'white'};

		this.numText = new PIXI.Text(num, numStyle);

		var textStyle = {
			fontSize:(this.fontSizeBase*2.7),
			letterSpacing:1,
			fontFamily:'Crimson Text,serif',
			fill:'white',
			wordWrap:true,
		};
		this.textText = new PIXI.Text(text, textStyle);
		
		this.container = new PIXI.Container();
		this.container.mask = this.mask;
		this.inner = new PIXI.Container();

		Main.instance.stage.addChild(this.container);
		this.container.addChild(this.inner);
		this.inner.addChild(this.numText);
		this.inner.addChild(this.textText);

		this.inner.calculateBounds();
		this.inner.x = -500;
		//テキスト

		//縦、横で配置が変わる
		if(this.border) {
			var line = new PIXI.Graphics();
			this.line = line;
			line.beginFill(0xFFFFFF);
			line.drawRect(0, 0, 1, Const.CONTENT_HEIGHT);
			line.endFill();
			
			Main.instance.stage.addChild(line);
			this.line.alpha = 0;
			
		}
		
	}

	start(delay?:number){
		if(this.border) {
			TweenMax.to(this.line, 0.5, {alpha:0.5});
		}
		TweenMax.to(this.inner, 0.75, {x:0,ease:Power2.easeInOut,delay:0.1*delay});
	}

	active(data:PIXI.Point){
		this.back.on('click',this.onClick.bind(this));
		this.back.on('touchstart',this.onTouchStart.bind(this));
		this.back.on('touchmove',this.onTouchMove.bind(this));
		this.back.on('touchend',this.onTouchEnd.bind(this));

		this.back.on('mouseover',this.onOver.bind(this));
		this.back.on('mouseout',this.onOut.bind(this));
		this.back.buttonMode = true;
		if(this.back.containsPoint(data)) {
			this.tween = TweenMax.to(this.back, 0.5, {alpha: 1});
		}
	}


	data:PIXI.interaction.InteractionData;
	sy:number;
	ey:number;

	onTouchStart(e){
		this.data = e.data;
		this.sy = this.data.global.y;
		this.ey = this.data.global.y;
		//this.tween = TweenMax.to(this.back, 0.2, {alpha: 0.4});
	}

	onTouchMove(e){
		//console.log(e.data);
		this.ey = e.data.global.y;
		//e.preventDefault();
		//this.tween = TweenMax.to(this.back, 0.01, {alpha: 0});
	}

	onTouchEnd(e){
		if(this.tween) {
			this.tween.pause(0);
		}
		if(this.sy+5 > this.ey  && this.sy-5 < this.ey) {
			this.goLink();
		}

	}

	goLink(){
		if(this.target === 'blank') {
			window.open().location.href = this.link;
		} else {
			window.location.href = this.link;
		}
	}


	flash(){
		if(this.device !== 'pc'){
			TimelinePlus.serial(
				TweenMax.to(this.back, 0.1, {alpha: 0.5}),
				TweenMax.to(this.back, 1, {alpha: 0})
			)
		} else {
			TimelinePlus.serial(
				TweenMax.to(this.back, 0.1, {alpha: 1}),
				TweenMax.to(this.back, 1, {alpha: 0})
			)
		}
	}

	onClick(e){
		console.log('Click',this.target);
		this.goLink();
	}
	
	tween:TweenMax;
	onOver(e){
		this.tween = TweenMax.to(this.back, 0.5, {alpha: 1});
	}

	onOut(e){
		if(this.tween) {
			this.tween.pause(0);
		}
	}

	device:string = 'pc';

	resize(x:number,y:number,w:number,h:number,vertical:Boolean,device:string){
		const ratio = window.devicePixelRatio || 1;
		var fontRetio:number = 1;

		this.device = device;
		if(device !== 'pc'){
			this.back.blendMode = PIXI.BLEND_MODES.ADD;
		} else {
			this.back.blendMode = PIXI.BLEND_MODES.OVERLAY;
		}

		if(vertical===true) {
			var startX:number = (this.id===0)?30:31;
			var startY:number = 20;

			if(device === 'pc') {
				fontRetio = 1;
				startY = 20;
			} else if(device === 'tab') {
				fontRetio = 1.2;
				startY = 20;
			} else {
				fontRetio = 0.6;
				startY = h*0.14;
				startX = h*0.2;
			}

			this.container.x = startX;
			this.container.y = y + startY;
			
			this.numText.style.fontSize = this.fontSizeBase*5.3*fontRetio;
			this.numText.calculateBounds();
			this.textText.style.wordWrap=false;
			this.textText.style.fontSize =this.fontSizeBase*2.7*fontRetio;
			this.textText.calculateBounds();
			this.textText.x = this.numText.x+this.numText.width+(11*fontRetio);
			this.textText.y = this.numText.y+this.numText.height - this.textText.height-4;
			
			this.mask.clear();
			this.mask.beginFill(0xFF0000);
			this.mask.drawRect(0,y,w,h);
			this.mask.endFill();


			//縦
			this.back.x = x;
			this.back.y = y;
			this.back.width = w;
			this.back.height = h;
			if(this.border) {
				this.line.clear();
				this.line.beginFill(0xFFFFFF);
				this.line.drawRect(0, y, w, 1);
				this.line.endFill();
			}
		} else {
			//横
			var startX:number = (this.id===0)?30:31;
			var startY:number = 70;
			if(device === 'pc') {
				fontRetio = 1;
				startY=70;
			} else if(device === 'tab') {
				fontRetio = 1;
				startY=70;
			} else {
				fontRetio = 0.6;
				startY=30;
				startX = w*0.2;
			}

			this.container.x = x+startX;
			this.container.y = startY;
			
			this.numText.style.fontSize=this.fontSizeBase*5.3*fontRetio;
			this.numText.calculateBounds();
			this.textText.style.wordWrap=true;
			this.textText.style.wordWrapWidth = w-(startX+10);
			//console.log(this.textText.style.wordWrapWidth);
			//this.textText.style.wordWrapWidth = 220;
			this.textText.style.fontSize =this.fontSizeBase*2.7*fontRetio;
			this.textText.calculateBounds();
			if(w<320) {
				this.textText.x = 0;
				this.textText.y = this.numText.y+this.numText.height;
			} else {
				this.textText.x = this.numText.x+this.numText.width + 11;
				this.textText.y = this.numText.y+this.numText.height - this.textText.height-4;
			}
			console.log(x,y,w,h);
			this.back.x = x;
			this.back.y = y;
			this.back.width = w;
			this.back.height = h;
			
			this.mask.clear();
			this.mask.beginFill(0xFF0000);
			this.mask.drawRect(x,0,w,h);
			this.mask.endFill();

			if(this.border) {
				this.line.clear();
				this.line.beginFill(0xFFFFFF);
				this.line.drawRect(x, 0, 1, h);
				this.line.endFill();
			}
		}
	}


}

